// extracted by mini-css-extract-plugin
export default {"container":"callout-styles_component_container__MudAE","title":"callout-styles_component_title__l0kn7","body":"callout-styles_component_body__WTRwJ"};